<template>
  <el-card>
    <div v-wechat-title="title" />

    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <el-col :span="2">
        <div class="demo-basic--circle">
          <div class="block"><el-avatar shape="square" :size="50" :src="form.wx_headimg" /></div>
        </div>
      </el-col>
      <el-col>
        <strong>{{ form.real_name }}</strong>
        <div style="margin: 8px;" />
        <span>{{ form.level_name }}</span>
      </el-col>
    </el-row>

    <el-divider content-position="right">概要&汇总</el-divider>

    <el-row type="flex" justify="left">
      <el-col>
        <el-tabs type="card" tab-position="top">
          <el-tab-pane label="会员信息"><user-info :user.sync="form" @refreshData="refreshData"/></el-tab-pane>
          <el-tab-pane label="授权证书"><user-detail-auth :data.sync="form"/></el-tab-pane>
          <el-tab-pane label="代理树"><user-agent-tree :data.sync="form"/></el-tab-pane>
          <el-tab-pane label="安置树"><user-posit-tree :data.sync="form"/></el-tab-pane>
          <el-tab-pane label="订单"><user-order-list :data="form"/></el-tab-pane>
          <el-tab-pane label="复销余额日志"><user-advance-logs :data="form"/></el-tab-pane>
          <el-tab-pane label="奖金日志"><user-rebate-logs :data="form"/></el-tab-pane>
          <el-tab-pane label="报单余额日志"><user-bill-balance-logs :data="form"/></el-tab-pane>
          <el-tab-pane label="人物关系"><user-detail-relations :user="form" @refreshData="refreshData"/></el-tab-pane>
          <el-tab-pane label="分红考核"><user-detail-share-bonus :data="form"/></el-tab-pane>
          <el-tab-pane label="等级升级" v-if="form.level_id <= 4"><user-detail-upgrade-activity :data="form"/></el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { editUser, updateUser, storeUser, createUser } from '@/api/users'
import FormHelper from '@c/LzForm/FormHelper'
import UserInfo from './components/UserInfo'
import UserDetailAuth from './components/UserDetailAuth'
import UserAgentTree from './components/UserAgentTree'
import UserPositTree from './components/UserPositTree'
import UserOrderList from './components/UserOrderList'
import UserAdvanceLogs from './components/UserAdvanceLogs'
import UserRebateLogs from './components/UserRebateLogs'
import UserBillBalanceLogs from './components/UserBillBalanceLogs'
import UserDetailRelations from './components/UserDetailRelations'
import UserDetailShareBonus from './components/UserDetailShareBonus'
import UserDetailUpgradeActivity from './components/UserDetailUpgradeActivity' // 等级升级

export default {
  name: 'UserForm',
  components: {
    UserDetailAuth,
    UserInfo,
    UserAgentTree,
    UserPositTree,
    UserOrderList,
    UserAdvanceLogs,
    UserRebateLogs,
    UserBillBalanceLogs,
    UserDetailRelations,
    UserDetailShareBonus,
    UserDetailUpgradeActivity,
  },
  mixins: [FormHelper],
  data() {
    return {
      title: '编辑会员',
      form: {
        id: 0,
        username: '',
        real_name: '',
        wechat: '',
        mobile: '',
        idcard_no: '',
        idcard_photo: '',
        status: '',
        status_text: '',
        accredit_opt_id: '',
        accredit_opt_time: '',
        level_id: 5,
        level_name: '',
        level_info: {},
        parent_id: '',
        parent_user: {},
        path: '',
        referee_user_id: '',
        total_balance: '',
        bill_balance: '',
        temp_rebate: '',
        total_rebate: '',
        locked_rebate: '',
        total_integral: '',
        agent_area_codes: '',
        agent_area_names: '',
        city: '',
        city_code: '',
        district: '',
        district_code: '',
        province: '',
        province_code: '',
        area_text: '',
        recruit_disabled: '',
        agent_disabled: '',
        enable_withdrawal: '',
        register_type: '',
        register_type_text: '',
        register_ip: '',
        last_login_time: '',
        login_times: '',
        wx_headimg: '',
        wx_nickname: '',
        wx_openid: '',
        posit_no: '',
        posit_parent_id: '',
        posit_path: '',
        auth_code_prefix: '',
        auth_code_no: '',
        auth_code: '',
        auth_begin_time: '',
        auth_end_time: '',
        auth_remark: '',
        enable_deliver: '',
        is_default_user: '',
        allow_share_fund: '',
        allow_invite_rebate: '',
        allow_order_rebate: '',
        debit_advice_status: '',
        debit_advice_status_text: '',
        current_performance: '',
        repeat_sale_counter_total: '',
        repeat_sale_counter_relative: '',
        relations: [],
        posit_parent_user: [],
        user_change_logs: [],
        team_list: [],
        direct_team_list: [],
        created_at: '',
        updated_at: '',
      },
      squareUrl: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editUser(this.resourceId))
        this.fillForm(data)

        this.title = data.real_name
        this.$route.meta.title = this.title
        this.$store.dispatch('tagsView/updateVisitedView', this.$route)
      } else {
        ;({ data } = await createUser())
      }
    },
    async refreshData() {
      this.getData()
    },
  },
}
</script>

<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  text-align: middle;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
